<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Planos</h5>
                <hr>
				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>												
					</template>
				</Toolbar>
				<DataTable :value="planos"  :autoLayout="true"  :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">					
					<Column field="nome" header="Nome" sortable></Column>	
					<Column field="valorMensal" header="Valor Mensal" dataType="numeric" style="min-width: 8rem">
					  <template #body="{data}">
						{{formatCurrency(data.valorMensal)}}
					  </template>					  
					</Column>
					<Column field="valorAnual" header="Valor Anual" dataType="numeric" style="min-width: 8rem">
					  <template #body="{data}">
						{{formatCurrency(data.valorAnual)}}
					  </template>					  
					</Column>	
					<Column field="quantidadePessoas" header="Limite de Pessoas" sortable></Column>
                    <Column field="quantidadeUsuarios" header="Limite de Usuários" sortable></Column>
					<Column field="quantidadeCNPJs" header="Limite de CNPJs" sortable></Column>
                    <Column field="quantidadeUsuariosApp" header="Limite de Usuários App" sortable></Column>
					<Column field="validade" header="Validade" sortable>
						<template #body="{data}">
							<label v-if="data.validade == 'Producao'">Produção</label>
							<label v-if="!data.validade == 'Teste'">Teste</label>
						</template>
					</Column>
					<Column field="ativo" header="Ativo" sortable>
						<template #body="{data}">
							<label v-if="data.ativo">Sim</label>
							<label v-if="!data.ativo">Não</label>
						</template>
					</Column>							
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>							
						</template>
					</Column>
				</DataTable>
				<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
						<span>Excluir Plano <b>{{ planoSelecionado.nome }}</b>?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>
			</div>
		</div>
	</div>
</template>

<script>

import PlanoService from '@/service/PlanoService';
import Plano from '@/model/Plano';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	planoService: null,
	data() {
		return {
			enviandoForm: false,
			permissaoExcluir: false,
			permissaoNovo: false,
			permissaoEditar: false,	
			exibirDialogConfirmarExcluir: false,
			planoSelecionado: new Plano(),
            planos: [],
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),	
		listar() {
			let requisicao = {				
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.planoService.listarTodos(requisicao)
				.then(resp => {			
					this.planos = resp.data;						
                })
                .catch(erro => {exibirMensagem(this, erro)});

		},			
		novo() {
			let mapBeneficios = new Map();
			this.planos.forEach(plan => {
				plan.beneficios.forEach(ben => {
					if(mapBeneficios.get(ben.nome) == null) {
						let b = {...ben};
						b.id = null;
						b.selecionado = true;
						mapBeneficios.set(ben.nome, b);
					}
				});
			});			
			// Todos os benefícios, comuns, serão colocados na sessão para serem usados no novo plano.
			sessionStorage.setItem('sessionBeneficiosPlanoNovo', JSON.stringify(Array.from(mapBeneficios.values())));
			this.$router.push('/cadastro/planos/novo');
		},
		editar(plano) {
			this.$router.push('/cadastro/planos/'+plano.id+'/editar');
		},
		excluir() {
			let requisicao = {
				plano: {...this.planoSelecionado},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
			this.planoService.excluir(requisicao)
				.then(resp => {	
					this.enviandoForm = false; 
					this.fecharModal();
					this.listar();
					exibirMensagem(this, resp);						
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},		
		confirmarExcluir(plano) {
			this.planoSelecionado = plano;
			this.exibirDialogConfirmarExcluir = true;
		},
		fecharModal() {
			this.exibirDialogConfirmarExcluir = false;
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(99999);
			this.permissaoEditar = permissoes.includes(99999);		
			this.permissaoExcluir = permissoes.includes(99999);		
		},
		formatCurrency(value) {
            return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
        },
	},	
	created() {
		this.planoService = new PlanoService();		
	},
	mounted() {					
		this.validarPermissoes();	
		this.listar();	
	}
}
</script>

<style scoped>
</style>